export const JAEGER_PROCESS_TAG_FIELD = 'process.tag';
//# sourceMappingURL=jaeger-process-tag-field.js.map